import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'combinearray'
})
export class CombineArrayPipe implements PipeTransform {

  transform(arr:any[]) {
    return arr.join(', ')
  }
}